import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import qs from 'qs';

import { getFormValues, submit, isSubmitting, isDirty } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Progress from 'components/common/Progress';
import Dialog, {
  DialogContent,
  DialogTitle,
  DialogActions,
} from 'components/common/Dialog';
import Button from 'components/common/Button';

import { fetchBusiness } from 'redux/modules/business';

import throttle from 'utils/throttle';

import InsuranceCreateEditForm from 'components/patient/InsuranceCreateEditDialog/InsuranceCreateEditForm';
import PrintDialogForm from 'components/common/PrintDialog/PrintDialogForm';

import BusinessGeneralCompanyInformationForm from './BusinessGeneralCompanyInformationForm';
import BusinessGeneralContactInformationForm from './BusinessGeneralContactInformationForm';
import BusinessGeneralCompanyLogoForm from './BusinessGeneralCompanyLogoForm';
import BusinessGeneralCompanyAddressForm from './BusinessGeneralCompanyAddressForm';
import BusinessGeneralCompanyIdentifiersForm from './BusinessGeneralCompanyIdentifiersForm';

const steps = [
  'companyInformation',
  'contactInformation',
  'companyLogo',
  'companyAddress',
  'companyIdentifiers',
];

const styles = () => ({
  action: {
    '&:first-child': {
      position: 'absolute',
      left: 14,
      top: 17,
    },
  },
  dialogContent: {
    minHeight: 266,
  },
});

class BusinessGeneralDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 0,
    };

    this.onDialogEnter = this.onDialogEnter.bind(this);
    this.onSkipStep = this.onSkipStep.bind(this);
    this.onBackButtonClick = this.onBackButtonClick.bind(this);
    this.onSubmitSuccessStep = this.onSubmitSuccessStep.bind(this);
  }


  onDialogEnter() {
    this.props.actions.fetchBusiness({
      triggerLoading: true,
    });
  }

  onSkipStep() {
    if (this.state.currentStep < 4) {
      this.setState({ currentStep: this.state.currentStep + 1 });
    } else {
      this.props.onClose();
    }
  }

  onBackButtonClick() {
    this.setState({ currentStep: this.state.currentStep - 1 });
  }

  onSubmitSuccessStep() {
    if (this.state.currentStep < 4) {
      this.setState({ currentStep: this.state.currentStep + 1 });
    } else {
      this.props.onClose();
    }
  }

  render() {
    const {
      open,
      onClose,
      loading,
      actions,
      business,
      appInfo,
      companyInformationDirty,
      contactInformationDirty,
      companyLogoDirty,
      companyAddressDirty,
      companyIdentifiersDirty,
      classes,
    } = this.props;
    const { currentStep } = this.state;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        onEnter={this.onDialogEnter}
        onExited={this.onDialogExited}
        maxWidth="sm"
      >
        <DialogTitle
          onCloseClick={onClose}
          {...currentStep !== 0 ? { onBackClick: this.onBackButtonClick } : {}}     
        >
          <Typography
            variant="title"
            color="secondary"
            align="center"
          >
            {steps[currentStep] === 'companyInformation' && <Fragment>Let's Get Your Organization Set Up</Fragment>}
            {steps[currentStep] === 'contactInformation' && <Fragment>Our Software has ready made Templates</Fragment>}
            {steps[currentStep] === 'companyLogo' && <Fragment>Get Customized</Fragment>}
            {steps[currentStep] === 'companyAddress' && <Fragment>Our Software has ready made Templates</Fragment>}
            {steps[currentStep] === 'companyIdentifiers' && <Fragment>Our Software has ready made Templates</Fragment>}
          </Typography>
        </DialogTitle>
        <DialogContent
          className={classes.dialogContent}
          disableGutters
        >
          {(loading > 0) ? (
            <Progress />
          ) : (
            <Fragment>
              {steps[currentStep] === 'companyInformation' &&
                <BusinessGeneralCompanyInformationForm
                  form={steps[currentStep]}
                  onSubmitSuccess={this.onSubmitSuccessStep}
                  {...business['Company Info'] && business['Company Info'].ID ? { initialValues: {
                    'Company Name': business['Company Info']['Company Name'],
                    'Signer First Name': business['Company Info']['Signer First Name'],
                    'Signer Last Name': business['Company Info']['Signer Last Name'],
                    ID: business['Company Info'].ID,
                  }} : {}}
                />
              }
              {steps[currentStep] === 'contactInformation' &&
                <BusinessGeneralContactInformationForm
                  form={steps[currentStep]}
                  onSubmitSuccess={this.onSubmitSuccessStep}
                  {...business['Company Contact'] && business['Company Contact'].ID ? { initialValues: {
                    'Phone Number': business['Company Contact']['Phone Number'],
                    'Fax': business['Company Contact'].Fax,
                    'Company Email': business['Company Contact']['Company Email'],
                    'Company Website': business['Company Contact']['Company Website'],
                    ID: business['Company Contact'].ID,
                  }} : {}}
                />
              }
              {steps[currentStep] === 'companyLogo' &&
                <BusinessGeneralCompanyLogoForm
                  form={steps[currentStep]}
                  onSubmitSuccess={this.onSubmitSuccessStep}
                  {...business.Image && business.Image['File Name'] ? { initialValues: {
                    Image: {
                      name: business.Image['File Name'],
                      preview: `${business.Image['File Url']}${business.Image['File Name']}`,
                    },
                    ID: business.ID,
                  }} : {
                    initialValues: { ID: business.ID },
                  }}
                />
              }
              {steps[currentStep] === 'companyAddress' &&
                <BusinessGeneralCompanyAddressForm
                  form={steps[currentStep]}
                  onSubmitSuccess={this.onSubmitSuccessStep}
                  {...business['Company Address'] && business['Company Address'].ID ? { initialValues: {
                    'Street': business['Company Address'].Street,
                    'Apt': business['Company Address'].Suite,
                    'City': business['Company Address'].City,
                    'State': business['Company Address'].State,
                    'Zip Code': business['Company Address']['Zip Code'],
                    ID: business['Company Address'].ID,
                  }} : {
                    initialValues: {
                      'Company ID': business.ID,
                      'Observes Daylight Saving': false,
                      'Time Zone': 'US/Eastern',
                    },
                  }}
                />
              }
              {steps[currentStep] === 'companyIdentifiers' &&
                <BusinessGeneralCompanyIdentifiersForm
                  form={steps[currentStep]}
                  onSubmitSuccess={this.onSubmitSuccessStep}
                  {...business['Company Identify'] && business['Company Identify'].ID ? { initialValues: {
                    'Practice NPI': business['Company Identify']['Practice NPI'],
                    'EIN': business['Company Identify'].EIN,
                    'Trading Partner ID': business['Company Identify']['Trading Partner ID'],
                    'MEDICARE': business['Company Identify'].MEDICARE,
                    'MEDICAID': business['Company Identify'].MEDICAID,
                    'Primary Taxonomy': business['Company Identify']['Primary Taxonomy'],
                    ID: business['Company Identify'].ID,
                  }} : {
                    initialValues: { 'Company ID': business.ID },
                  }}
                />
              }
            </Fragment>
          )}
        </DialogContent>
        <DialogActions
          classes={{ action: classes.action }}
        >
          <Typography variant="caption">
            STEP {currentStep + 1}/5
          </Typography>
          <Button
            onClick={this.onSkipStep}
            variant="raised"
          >
            Skip
          </Button>
          <Button
            onClick={() => {
              if ((steps[currentStep] === 'companyInformation' && companyInformationDirty)
              || (steps[currentStep] === 'contactInformation' && contactInformationDirty)
              || (steps[currentStep] === 'companyLogo' && companyLogoDirty)
              || (steps[currentStep] === 'companyAddress' && companyAddressDirty)
              || (steps[currentStep] === 'companyIdentifiers' && companyIdentifiersDirty)) {
                actions.submit(steps[currentStep]);
              } else {
                this.onSkipStep();
              }
            }}
            variant="raised"
            color="primary"
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

BusinessGeneralDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchBusiness: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    action: PropTypes.string.isRequired,
  }).isRequired,
};

BusinessGeneralDialog.defaultProps = {
  open: false,
  business: {},
};

const mapStateToProps = (store, ownProps) => {
  return {
    business: store.business.data,
    loading: store.business.loading,
    appInfo: store.appInfo,
    companyInformationDirty: isDirty('companyInformation')(store),
    contactInformationDirty: isDirty('contactInformation')(store),
    companyLogoDirty: isDirty('companyLogo')(store),
    companyAddressDirty: isDirty('companyAddress')(store),
    companyIdentifiersDirty: isDirty('companyIdentifiers')(store),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchBusiness,
    submit,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(BusinessGeneralDialog),
);



// WEBPACK FOOTER //
// ./src/components/settings/BusinessGeneralDialog/BusinessGeneralDialog.js